import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  CircularProgress,
} from '@mui/material';
import { parseAnalyteCodeString } from './cutoffUtils';

const ModifyPrimaryAnalyteDialog = ({
  open,
  onClose,
  onSave,
  condition,
  analyteLookupOptions,
  getCutoffConditionDisplayName,
  saving,
}) => {
  const [selectedPrimaryAnalytes, setSelectedPrimaryAnalytes] = useState([]);
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open && condition) {
      const primaryAnalyte = condition.primaryAnalyte || condition.PrimaryAnalyte || '';
      const codes = parseAnalyteCodeString(primaryAnalyte);
      setSelectedPrimaryAnalytes(codes);
      setSaveAttempted(false);
    } else if (!open) {
      setSelectedPrimaryAnalytes([]);
      setSaveAttempted(false);
    }
  }, [open, condition]);

  const selectedOptions = (analyteLookupOptions || []).filter(
    (opt) => selectedPrimaryAnalytes.includes(opt.value)
  );

  const handleSave = () => {
    setSaveAttempted(true);
    if (selectedPrimaryAnalytes.length === 0) return;
    onSave(condition, selectedPrimaryAnalytes.join(','));
  };

  const hasError = saveAttempted && selectedPrimaryAnalytes.length === 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="modify-primary-analyte-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="modify-primary-analyte-dialog-title" sx={{ textAlign: 'center' }}>
        Modify Primary Analyte(s){condition ? ` — ${getCutoffConditionDisplayName(condition)}` : ''}
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          sx={{ mt: 1 }}
          size="small"
          multiple
          id="modifyPrimaryAnalytes"
          options={analyteLookupOptions || []}
          value={selectedOptions}
          onChange={(event, newValue) => setSelectedPrimaryAnalytes(newValue.map((opt) => opt.value))}
          getOptionLabel={(option) => option?.description ? `${option.description} (${option.label})` : (option?.label || '')}
          isOptionEqualToValue={(option, value) => option?.value === value?.value}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Primary Analyte(s)"
              variant="outlined"
              size="small"
              required
              error={hasError}
              helperText={hasError ? 'At least one primary analyte is required.' : ''}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? 'Saving...' : 'OK'}
        </Button>
        <Button onClick={onClose} variant="outlined" disabled={saving}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModifyPrimaryAnalyteDialog;
